import { SHOW_REFRESH_MODAL, SET_LOAN_ID_FOR_ENCOMPASS } from '../../common/socket/actions'

const defaultState = {
  showRefreshModal: false,
  loanIdForEncompass: null,
}

export default function(state = defaultState, action) {
  switch (action.type) {
    case SHOW_REFRESH_MODAL:
      return {
        ...state,
        showRefreshModal: action.showRefreshModal,
      }
    case SET_LOAN_ID_FOR_ENCOMPASS:
      return {
        ...state,
        loanIdForEncompass: action.loanIdForEncompass,
      }
    default:
      return state
  }
}
